import './DataTableSelectionChip.css';
export var selectionChip = '_1rlvxpp4-3-5-0';
export var selectionChipWrapper = {condensed:'_1rlvxpp1-3-5-0 _1rlvxpp0-3-5-0','default':'_1rlvxpp2-3-5-0 _1rlvxpp0-3-5-0',comfortable:'_1rlvxpp3-3-5-0 _1rlvxpp0-3-5-0'};